<template>
  <div class="contact_us_edit" :style="styleObj">
    <div class="contact_us_dialog_frame">
      <div
        class="close_edit_panel_btn"
        @click="dialog_close"
      >
        <i class="close_edit_panel_icon el-icon-close"></i>
      </div>
      <div class="contact_us_dialog_content">
        <div class="layout_row_edit">
          <el-tabs class="edit_top_tabs">
            <el-tab-pane label="contact us">
              <!--移动端下的布局设置-->
              <div class="edit_item">
                <my_radio
                  titleWidth="65"
                  :option="option"
                  :selectValue.sync="contact_us_set.radio_val"
                  :title="$t('view_back_top_edit_95')"
                  tips
                  iconIsShow="right"
                  class="m-lr-0"
                >
                </my_radio>
              </div>
              <!-- 系统设置默认的按钮样式 -->
              <div
                class="edit_content_list"
                v-if="contact_us_set.radio_val == 'default' && editIconList.length"
              >
                <div
                  class="contact_us_list"
                  v-for="item in editIconList"
                  :key="item.id"
                  :class="{'active': contact_us_set.default.id == item.id }"
                  @click="toggleIcon(item)"
                >
                  <div class="icon_list_com" :style="default_style(item)" ></div>
                  <div
                    class="icon_checked_icon"
                    v-if="contact_us_set.default.id == item.id "
                  >
                    <span class="el-icon-check"></span>
                  </div>
                </div>
                <div class="contact_us_list" style="visibility:hidden"></div>
              </div>
              <!-- 系统图标 可以显示的 联系 -->
              <my_img_button
                v-if="contact_us_set.radio_val == 'customSet'"
                titleWidth="62"
                :title="$t('view_back_top_edit_96')"
                :buttonTitle="$t('view_back_top_edit_97')"
                tipsWidth="250"
                type="one_level"
                :tips="$t('view_back_top_edit_98')"
                @uploadImg="uploadImg"
                :imgUrl.sync="contact_us_set.customSet.url"
              ></my_img_button>
              <!--  @update:imgUrl="imgUrlChange" -->
              <my_radio
                titleWidth="70"
                v-if="contact_us_set.radio_val == 'default' && color_can_change"
                :option="option1"
                :selectValue.sync="select_color"
                :title="$t('view_back_top_edit_99')"
                tips
                iconIsShow="right"
              >
                <div slot="pull_down_control">
                  <my_color
                    titleWidth="70"
                    type="one_level"
                    :color.sync="contact_us_data.backgroundColor"
                    :title="$t('view_contact_us_edit_106')"
                    class="select_color"
                  ></my_color>
                </div>
              </my_radio>
              <my_link
                :value.sync="listArr.link.select_val_preview"
                :title="$t('view_contact_us_edit_107')"
                titleWidth="60"
                :link="listArr.link"
                class="link-set"
                :link-fun="true"
                :contact-us='true'
              ></my_link>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import { mapMutations} from 'vuex'
export default {
  name: 'contact_us_edit',
  props: {
    styleObj: {
      type: Object,
      default: function () {
        return { bottom: '70px', right: '120px' }
      }
    },
    iconList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data(){
    return{
      option: [{
        value: 'default',
        label: i18n.t('view_back_top_edit_101')
      },
      {
        value: 'customSet',
        label: i18n.t('view_back_top_edit_102')
      }],
      option1: [{
        value: 'default',
        label: i18n.t('view_back_top_edit_101')
      },
      {
        value: 'custom',
        label: i18n.t('view_back_top_edit_102')
      }],
      editIconList: this.iconList,
      select_color: 'default',
      // select_button: 'default',
      color_can_change: true
    }
  },
  mounted() {
    //框拖拽
    $('.contact_us_edit').draggable({
      containment: 'window',
    })
    this.select_color = this.contact_us_data.backgroundColor === 'rgba(55, 85, 239, 1)' ? 'default' : 'custom'
  },
  computed: {
    contact_us_set() {
      return this.$store.state.myRender.common.contact_us.contact_us_set
    },
    contact_us_data() {
      return this.contact_us_set.default
    },
    default_style(){
      return function(item) {
        let style = {
        backgroundPosition: item.iconPosition,
        borderRadius: item.borderRadius
      }
      if(item.canChangeColor) {
        style.backgroundColor= this.contact_us_data.backgroundColor
      }
      return style
      }
    },
    listArr() {
      return this.$store.state.myRender.common.contact_us.listArr
    }
  },
  methods: {
    dialog_close () {
      this.$emit('changeShow')
    },
    toggleIcon(item){  // 系统属性ICON切换
      this.set_contact_us_set_default({
        ...item,
        backgroundColor: this.contact_us_data.backgroundColor ? this.contact_us_data.backgroundColor:  'rgba(55, 85, 239, 1)'// 要把颜色修改成 我们 选中的颜色
      })
      this.color_can_change = item.canChangeColor
    },
    uploadImg () {
      this.$store.commit('image_upload/set_showTag', true);
      this.$store.commit('image_upload/set_fileType', 1);
      this.$store.commit('image_upload/set_fileLimit', 1);
      this.$store.state.image_upload.imgFile = (e) => {
        // this.imgUrl = e && e[0].filePath;
        this.set_contact_us_set_custom_url(e && e[0].filePath)
        this.$store.state.image_upload.imgFile = null
      }
    },
    ...mapMutations('myRender',['set_contact_us_set_default', 'set_contact_us_set_default_bg', 'set_contact_us_set_custom_url'])
  },
  watch: {
    select_color() { // 颜色 设置默认值的时候要进行恢复 UI 设计图的颜色
      if(this.select_color === 'default') this.set_contact_us_set_default_bg('rgba(55, 85, 239, 1)')
    }
  }
};
</script>

<style scoped lang="scss">
.contact_us_edit {
  position: fixed;
  width: 380px;
  max-height: 570px;
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  height: calc(100% - 80px);
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  z-index: 2002;
  .contact_us_dialog_frame {
    position: relative;
    width: 100%;
    height: 100%;
    /*overflow-y: auto;*/
    .close_edit_panel_btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 65px;
      height: 65px;
      cursor: pointer;
      line-height: 58px;
      font-size: 30px;
      text-align: center;
      z-index: 10;
      color: #fff;
      i {
        font-size: 23px;
      }
    }
    .contact_us_dialog_content {
      height: 100%;
      .layout_row_edit{
        /deep/{
          .edit_top_tabs .el-tabs__content{
            .edit_item{
              padding: 0 10px;
              margin-top:20px;
            }
          }
        }
      }
      .edit_content_list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 30px;
        .contact_us_list {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
           flex: 0 1 78px;
          height: 78px;
          margin: 0 12px 10px;
          box-sizing: border-box;
          overflow: hidden;
          border-radius: 2px;
          padding: 5px;
          border: 1px solid rgb(248, 242, 242); 
          cursor: pointer;
          &:hover {
            border: 1px solid #5874d8;
          }
          &.active {
            border: 1px solid #5874d8;
          }
          .icon_list_com {
            width: 49px;
            height: 49px;
            background-image:url("~@/assets/image/contact_us_icon.png");
            /* color: #fff;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15); */
          }
          .icon_checked_icon {
            position: absolute;
            right: -15px;
            bottom: -15px;
            height: 30px;
            width: 30px;
            font-size: 0;
            border-radius: 50%;
            background-color: #5874d8;
            span {
              display: inline-block;
              margin: 3px 0 0 3px;
              font-size: 12px;
              font-weight: bold;
              color: #fff;
            }
          }
        }
      }
    }
    .back_top_dialog_header {
      overflow: hidden;
      width: 100%;
      height: 58px;
      font-size: 0;
      background: #5874d8;
      -webkit-border-radius: 5px 5px 0 0;
      -moz-border-radius: 5px 5px 0 0;
      border-radius: 5px 5px 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contact_us/edit.vue